module.exports = __webpack_public_path__ + "img/NG.b5ab2900.svg";